import { Venue } from '~/store/venues/venues.types'

interface Region {
  region: string,
  venues: Array<Venue>
}

const getBedroomVenuesByRegion = (venues: Array<Venue>): Array<Region> => {
  return venues.reduce((filteredVenues: Array<Region>, currentVenue: Venue) => {
    const regionIndex = filteredVenues.findIndex(({ region }) => region === currentVenue.region)
    if (regionIndex >= 0) {
      filteredVenues[regionIndex].venues = [...filteredVenues[regionIndex].venues, currentVenue]
      return filteredVenues
    }

    return [
      ...filteredVenues,
      {
        region: currentVenue.region,
        venues: [currentVenue]
      }
    ]
  }, [])
}

export default getBedroomVenuesByRegion